<div class="flex flex-col gap-2 shrink-0">
  <app-collapsible-box
    [title]="'Patient details' | translate"
    [expanded]="true"
    [classes]="detailsBoxClasses"
    [attr.data-testid]="personalDetailsTestId">
    <app-details-fields
      view="personal"
      [variant]="variant"
      [copilot]="copilot"
      [emptyText]="'No details' | translate"
      [textClass]="textClass"
      [emptyClass]="emptyClass" />
  </app-collapsible-box>
  <app-collapsible-box
    [title]="'Visit details' | translate"
    [expanded]="true"
    [classes]="detailsBoxClasses"
    [attr.data-testid]="visitDetailsTestId">
    <app-details-fields
      view="visit"
      [variant]="variant"
      [copilot]="copilot"
      [emptyText]="'No details' | translate"
      [textClass]="textClass"
      [emptyClass]="emptyClass" />
  </app-collapsible-box>
</div>
